<section class="module-page">
    <section class="module-page-content">
        <section class="module-page-content-main">
            <section class="router-content">
                <router-outlet></router-outlet>
            </section>
        </section>
    </section>
</section>
